var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"currentColor","d":"M14.62,0a1.13,1.13,0,0,1,1.13,1.12v13.5a1.13,1.13,0,0,1-1.13,1.13H1.12A1.13,1.13,0,0,1,0,14.62V1.12A1.11,1.11,0,0,1,.33.33,1.11,1.11,0,0,1,1.12,0Zm-11,5a1.32,1.32,0,0,0,1-.41A1.29,1.29,0,0,0,5,3.6a1.31,1.31,0,0,0-.41-1,1.31,1.31,0,0,0-1-.4,1.24,1.24,0,0,0-.95.4,1.33,1.33,0,0,0-.39,1,1.31,1.31,0,0,0,.39.95A1.25,1.25,0,0,0,3.59,5ZM4.75,13.5h0V6H2.43V13.5Zm8.75,0V9.39A5.09,5.09,0,0,0,13,6.82a2.54,2.54,0,0,0-2.29-1,2.68,2.68,0,0,0-1.44.39A1.93,1.93,0,0,0,8.51,7h0V6H6.22V13.5H8.54V9.77a2.78,2.78,0,0,1,.25-1.33A1.23,1.23,0,0,1,10,7.84,1,1,0,0,1,11,8.51a3.6,3.6,0,0,1,.18,1.33V13.5Z"}))));
}

Linkedin.defaultProps = {"viewBox":"0 0 15.75 15.75"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
